import { atom, useAtom } from "jotai";
import { useCallback, useMemo } from "react";
import { configuration } from "../jotaiState";
import PRODUCTS_API from "../../services/products";

import get from "lodash/get";
import { useCoordinates } from "../location/coordinates";
import { getLatLong } from "../../utils/getCoords";
export const useAppConfiguration = () => {
  const { adjustCoordinates } = useCoordinates();
  const merchantDetails = JSON.parse(sessionStorage.getItem("merchantDetails"));
  const [appConfig, setAppConfig] = useAtom(configuration);
  const resetAppConfig = useCallback(async () => {
    if (get(merchantDetails, "merchantId") && get(merchantDetails, "storeId")) {
      const response = await PRODUCTS_API.getConfiguration({
        merchantId: get(merchantDetails, "merchantId"),
        storeId: get(merchantDetails, "storeId"),
      });
      setAppConfig(get(response, "data.scanQrSettings", {}) || {});
      const isDelivery = get(
        response,
        "data.scanQrSettings.generalSettings.isDeliveryAddress",
        false
      );
      if (isDelivery) {
        try {
          const result = await getLatLong();
          adjustCoordinates(result?.latitude, result?.longitude);
        } catch (err) {
          console.log(err, "Error getting location");
        }
      }
    }
  }, [merchantDetails]);

  return {
    appConfig,
    resetAppConfig,
  };
};
